import { BeamIcon } from 'beam/dist/BeamIcon'
import { BeamIconButton } from 'beam/dist/IconButton'
import { Snackbar } from 'beam/dist/Snackbar'
import { makeStyles } from 'beam/dist/styles'
import { useTranslation } from 'react-i18next'
import { func } from 'prop-types'

const useStyles = makeStyles(theme => ({
  snackbarError: {
    backgroundColor: theme.palette.error.main,
  },
}))

/** @deprecated use Common/NguiSnackbar with variant="error" instead */
export function ErrorSnackbar({ onClose = () => {}, ...restProps }) {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <Snackbar
      {...restProps}
      autohideDuration={null}
      onClose={onClose}
      ContentProps={{ className: classes.snackbarError }}
      action={
        <BeamIconButton key="close" aria-label={t('close')} color="inherit" onClick={onClose}>
          <BeamIcon>Close</BeamIcon>
        </BeamIconButton>
      }
    />
  )
}

ErrorSnackbar.propTypes = {
  onClose: func,
}
